import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
export const getTimeZone = () => {
    const _timezone = dayjs().utcOffset() / 60;
    const [hour, minute] = String(_timezone).split('.');
    const _minute = minute ? String(Number(minute) / 100 * 60) : '00';
    const timezone = `${(Number(hour) >= 0) && (Number(hour) < 10) ? '+0' : (Number(hour) >= 10) ? '+' : ''}${hour}:${_minute}`;
    return timezone;
};



// WEBPACK FOOTER //
// ./src/web-frontend-core/utils/getTime.js